var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalStepsImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4252 30.1414H26.8335C26.8335 30.1414 33.4517 30.1549 33.5418 30.1414L37.7201 29.3748C38.1614 29.294 38.5604 29.0611 38.8476 28.7164C39.1348 28.3718 39.292 27.9374 39.2918 27.4888V17.0736C39.2918 16.6883 39.1757 16.3119 38.9586 15.9936C38.7415 15.6753 38.4334 15.4298 38.0747 15.2892L28.4051 11.4999C27.9285 11.3135 27.4108 11.2577 26.9054 11.3382C26.4 11.4187 25.9252 11.6327 25.5301 11.958L18.5056 17.7368C18.2391 17.9549 18.0574 18.2595 17.9921 18.5976C17.9268 18.9357 17.9819 19.286 18.1479 19.5877C18.3139 19.8894 18.5803 20.1235 18.9009 20.2493C19.2214 20.3751 19.5759 20.3847 19.9028 20.2764L27.7918 17.6831",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7085 26.3082L11.6918 27.2665L18.5631 34.1378C18.78 34.355 19.0459 34.517 19.3384 34.61C19.6309 34.7031 19.9415 34.7245 20.244 34.6725L21.2023 34.5058C21.5927 34.4386 21.9526 34.2522 22.2327 33.9722C22.5128 33.6921 22.6992 33.3321 22.7663 32.9418L23.0998 31.0002L26.3754 30.4348L26.9408 27.1611L30.2164 26.5957L30.7799 23.3201L25.7966 18.3368",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.176 14.7161L19.3412 11.8833C19.0733 11.6144 18.7315 11.4311 18.3592 11.3567C17.9869 11.2823 17.6009 11.3202 17.2502 11.4655L11.5002 13.8498L6.7085 14.8081",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.958496 11.9331H4.79183C5.30016 11.9331 5.78767 12.135 6.14712 12.4945C6.50656 12.8539 6.7085 13.3414 6.7085 13.8498V27.2664C6.7085 27.7748 6.50656 28.2623 6.14712 28.6217C5.78767 28.9812 5.30016 29.1831 4.79183 29.1831H0.958496V11.9331Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2082 13.8499H45.0415V31.0999H41.2082C40.6998 31.0999 40.2123 30.8979 39.8529 30.5385C39.4934 30.179 39.2915 29.6915 39.2915 29.1832V15.7665C39.2915 15.2582 39.4934 14.7707 39.8529 14.4112C40.2123 14.0518 40.6998 13.8499 41.2082 13.8499Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStepsImg2);
export default __webpack_public_path__ + "static/media/legalStepsImg2.6ff594678747f5a4768311e2fe593030.svg";
export { ForwardRef as ReactComponent };